<dx-data-grid id="gridContainer" [dataSource]="activitiesDataSource" [remoteOperations]="true" [cacheEnabled]="false">
  <dxo-paging [enabled]="true" [pageSize]="ACTIVITIES_PAGE_LIMIT"></dxo-paging>
  <dxo-pager [showInfo]="true" infoText="Page #{0}. Total: {1} ({2} items)"> </dxo-pager>

  <dxi-column
    caption="Activity"
    cellTemplate="cellTemplate"
    dataField="event_payload.file_view"
    [allowSorting]="false"
    cssClass="no-border"
  ></dxi-column>
  <dxi-column
    caption="Date"
    dataField="event_datetime"
    sortOrder="desc"
    dataType="datetime"
    width="30%"
    cssClass="white-space-n"
    [format]="DATE_TIME_FORMAT_LONG"
  ></dxi-column>

  <div *dxTemplate="let data of 'cellTemplate'" class="white-space-n">
    <div
      *ngIf="ACTIVITIES_FILES_UPLOADED_EVENT === data.value.event"
      class="w-100 word-break"
      [attr.data-test-id]="'wrap-activities-text' + data.value.entity_id"
    >
      <app-activities-uploaded
        [activeUserId]="activeUserId$ | async"
        [data]="data"
        (displayPopup)="displayPopup($event)"
      >
      </app-activities-uploaded>
    </div>

    <div
      *ngIf="ACTIVITIES_FILES_UNSHARED === data.value.event"
      class="w-100 word-break"
      [attr.data-test-id]="'wrap-activities-text-' + data.value.entity_id"
    >
      <app-activities-unshared
        [activeUserId]="activeUserId$ | async"
        [data]="data"
        (displayPopup)="displayPopup($event)"
      >
      </app-activities-unshared>
    </div>

    <div
      *ngIf="ACTIVITIES_FILES_PERMISSION === data.value.event"
      class="w-100 word-break"
      [attr.data-test-id]="'wrap-activities-text-' + data.value.entity_id"
    >
      <app-activities-permission
        [activeUserId]="activeUserId$ | async"
        [data]="data"
        (displayPopup)="displayPopup($event)"
      >
      </app-activities-permission>
    </div>

    <div
      *ngIf="ACTIVITIES_FILES_SHARED === data.value.event"
      class="w-100 word-break"
      [attr.data-test-id]="'wrap-activities-text-' + data.value.entity_id"
    >
      <app-activities-shared
        [activeUserId]="activeUserId$ | async"
        [data]="data"
        (displayPopup)="displayPopup($event)"
      ></app-activities-shared>
    </div>

    <div
      *ngIf="ACTIVITIES_FILES_DOWNLOADED === data.value.event"
      class="w-100 word-break"
      [attr.data-test-id]="'wrap-activities-text-' + data.value.entity_id"
    >
      <app-activities-downloaded
        [activeUserId]="activeUserId$ | async"
        [data]="data"
        (displayPopup)="displayPopup($event)"
      ></app-activities-downloaded>
    </div>

    <div
      *ngIf="ACTIVITIES_FILES_REMOVED === data.value.event"
      class="w-100 word-break"
      [attr.data-test-id]="'wrap-activities-text-' + data.value.entity_id"
    >
      <app-activities-removed [activeUserId]="activeUserId$ | async" [data]="data"> </app-activities-removed>
    </div>
  </div>
</dx-data-grid>

<app-dev-popup
  [titleToDisplay]="titleToDisplay"
  [popupVisible]="popupVisible"
  [protectedPublicURL]="protectedPublicURL"
  [popupPublicURL]="popupPublicURL"
  [contentType]="typeOfContent"
  (hiding)="hidePopup()"
></app-dev-popup>
